import React, {useCallback, useEffect, useState} from "react";
//import ECharts, { EChartsReactProps } from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';
import {BarChart,} from 'echarts/charts';
import {
  AxisPointerComponent,
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import {SVGRenderer,} from 'echarts/renderers';

import Dropdown from "../component/Dropdown";
import Stats from '@common/enums/Stats.enums'
import NewDropdown from "../component/NewDropdown";
import useFetch from "@common/hooks/fetch/useFetch";
import {getStatInfo} from "@common/services/restapi/stat";
import {Moments} from "../../../common/utils/date/moments";

const STAT_MENU = [Stats.AdvertiserAdOutlay, Stats.IndustryAdOutlay, Stats.TvRating, Stats.MonthlyTvRating, Stats.PcDomain, Stats.MoblieApp];
const YEARS_MENU = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2001, 2000, 1999, 1998, 1997, 1996, 1995]
const MONTHS_MENU = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const DAYS_MENU = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]

function Stat() {
  // Register the required components
  const url = new URL(location.href);
  const urlParams = url.searchParams;
  const className = urlParams.get('className');
  echarts.use(
    [BarChart, GridComponent, TooltipComponent, AxisPointerComponent, LegendComponent, TitleComponent, DatasetComponent, SVGRenderer]
  );

  const [selectedStats, setSelectedStats] = useState(className ? Stats.enumValueOf(className) ?? STAT_MENU[0] : STAT_MENU[0]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedDay, setSelectedDay] = useState(Moments.MomentsDate(Moments.adDays(-1)));
  const [dataDate, setDataDate] = useState({year: null, month: null});

  const { data: { nameArr, newsArr, magazineArr, tvArr, radioArr, male, female, rating, reach, syears, smonths, smonth, syear, sday } } = useFetch(async () => {
    let searchQuery = {
      className: selectedStats.enumKey,
      year: selectedYear,
      month: selectedMonth,
    }

    if (selectedStats === Stats.TvRating) {
      searchQuery = {
        ...searchQuery,
        day: selectedDay,
      }
    }

    if (selectedYear && !selectedMonth) {
      searchQuery = {
        ...searchQuery,
        month: dataDate?.month,
      }
    } else if (!selectedYear && selectedMonth) {
      searchQuery = {
        ...searchQuery,
        year: dataDate?.year,
      }
    }

    const data = await getStatInfo(searchQuery);
    let { resultList = [], syears = YEARS_MENU, smonths = MONTHS_MENU, smonth = '', syear = '' } = data
    const nameArr = [];
    const newsArr = [];
    const magazineArr = [];
    const tvArr = [];
    const radioArr = [];
    const male = [];
    const female = [];
    const rating = [];
    const reach = [];
    let sday = '';

    if (resultList.length > 0) {
      const item = resultList[0];
      if ([Stats.TvRating].includes(selectedStats)) {
        const sdate = item?.sdate;
        if (sdate) {
          const dates = sdate.split('-');
          if (dates.length === 3) {
            syear = dates[0];
            smonth = dates[1];
            sday = dates[2];
          }
        }
      } else if ([Stats.MonthlyTvRating, Stats.PcDomain, Stats.MoblieApp].includes(selectedStats)) {
        syear = item.syear;
        smonth = item.smonth;
      }
    }

    resultList.forEach((item) => {
      nameArr.push(item.name);
      newsArr.push(item.newspaper);
      magazineArr.push(item.magazine);
      tvArr.push(item.tv);
      radioArr.push(item.radio);
      male.push(item.male);
      female.push(item.female);
      rating.push(item.rating);
      reach.push(item.reach);
    });

    return {
      nameArr,
      newsArr,
      magazineArr,
      tvArr,
      radioArr,
      male,
      female,
      rating,
      reach,
      syears,
      smonths,
      smonth,
      syear,
      sday,
    };
  }, [selectedStats, selectedYear, selectedMonth, selectedDay], { nameArr: [], newsArr: [], magazineArr: [], tvArr: [], radioArr: [], male: [], female: [], rating: [], reach: [] });

  const handleSelectThing = useCallback((selectThing) => {
    setSelectedStats(selectThing);
    setSelectedYear(null);
    setSelectedMonth(null);
    setSelectedDay(null);
  },[]);

  useEffect(() => {
    setDataDate({year: syear ?? '', month: smonth ?? ''});
  }, [syear, smonth]);

  const AdOutlayChart = () => {
    const [options, setOptions] = useState({
      tooltip: {
        trigger: 'axis',
        formatter: /*'<FormattedNumber value={c0}/>{a0}: {c0}원 <br/> {a1}: {c1}원 <br/> {a2}: {c2}원 <br/> {a3}: {c3}원'*/''
      },
      axisPointer: {
        type: 'shadow'
      },
      legend: {
        data: ['TV','라디오','신문','잡지',],
        padding: [20, 0, 0, 0],
        textStyle: {
          color : '#fff',
          fontSize : 10
        }
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 8,
          color : '#fff'
        },
        show: false
      },
      yAxis: {
        type: 'category',
        data: nameArr,
        max: 10,
        inverse: true,
        axisLabel: {
          fontSize: 8,
          color : '#fff'
        },
      },
      series: [
        {
          name: '잡지',
          type: 'bar',
          stack: 'one',
          data: magazineArr
        },
        {
          name: '신문',
          type: 'bar',
          stack: 'one',
          data: newsArr
        },
        {
          name: '라디오',
          type: 'bar',
          stack: 'one',
          data: radioArr
        },
        {
          name: 'TV',
          type: 'bar',
          stack: 'one',
          data: tvArr
        },
      ]
    });

    return (
      <ReactEChartsCore
        echarts={echarts}
        option={options}
        opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
      />
    );
    /*
    return (
      <ECharts
        option={options}
        opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
      />
    );*/
  }

  const AgencyEmployeeNumChart = () => {
    const [options, setOptions] = useState({
      tooltip: {
        trigger: 'axis',
        formatter: '{a0}: {c0}명 <br/> {a1}: {c1}명'
      },
      axisPointer: {
        type: 'shadow'
      },
      legend: {
        data: ['남자','여자',],
        padding: [20, 0, 0, 0],
        textStyle: {
          color : '#fff',
          fontSize : 10
        }
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 8,
          color : '#fff'
        },
        show: false
      },
      yAxis: {
        type: 'category',
        data: nameArr,
        max: 10,
        inverse: true,
        axisLabel: {
          fontSize: 8,
          color : '#fff'
        },
      },
      series: [
        {
          name: '남자',
          type: 'bar',
          stack: 'one',
          data: male
        },
        {
          name: '여자',
          type: 'bar',
          stack: 'one',
          data: female
        },
      ]
    });

    return (
      <ReactEChartsCore
        echarts={echarts}
        option={options}
        opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
      />
    );
    /*
    return (
      <ECharts
        option={options}
        opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
      />
    );*/
  }

  const RatingChart = () => {
    const [options, setOptions] = useState({
      tooltip: {
        trigger: 'axis',
        formatter: '{a0}: {c0}%'
      },
      axisPointer: {
        type: 'shadow'
      },
      legend: {
        data: ['시청률',],
        padding: [20, 0, 0, 0],
        textStyle: {
          color : '#fff',
          fontSize : 10
        }
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 8,
          color : '#fff'
        },
        show: false
      },
      yAxis: {
        type: 'category',
        data: nameArr,
        max: 10,
        inverse: true,
        axisLabel: {
          fontSize: 8,
          color : '#fff'
        },
      },
      series: [
        {
          name: '시청률',
          type: 'bar',
          stack: 'one',
          data: rating
        },
      ]
    });

    return (
      <ReactEChartsCore
        echarts={echarts}
        option={options}
        opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
      />
    );
    /*
    return (
      <ECharts
        option={options}
        opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
      />
    );*/
  }

  const DomainChart = () => {
    const [options, setOptions] = useState({
      tooltip: {
        trigger: 'axis',
        formatter: '{a0}: {c0}%'
      },
      axisPointer: {
        type: 'shadow'
      },
      legend: {
        data: ['도달률',],
        padding: [20, 0, 0, 0],
        textStyle: {
          color : '#fff',
          fontSize : 10
        }
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 8,
          color : '#fff'
        },
        show: false
      },
      yAxis: {
        type: 'category',
        data: nameArr,
        max: 10,
        inverse: true,
        axisLabel: {
          fontSize: 8,
          color : '#fff'
        },
      },
      series: [
        {
          name: '도달률',
          type: 'bar',
          stack: 'one',
          data: reach
        },
      ]
    });

    return (
      <ReactEChartsCore
        echarts={echarts}
        option={options}
        opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
      />
    );
    /*
    return (
      <ECharts
        option={options}
        opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
      />
    );*/
  }

  return (
    <>
      <div className="common-header--top">
        <h3 className="header-title">광고통계</h3>
      </div>

      <section className="stats">
        <div className="row-box">
          <NewDropdown
            additionalClassName="stats-select-list"
            thingsList={STAT_MENU}
            defaultValue={selectedStats}
            onSelectThing={handleSelectThing}
          />
          {
            selectedStats === Stats.TvRating ?
              <></>
              :
              <>
              <Dropdown
                additionalClassName="stats-select-list middle"
                thingsList={syears}
                selectedThing={selectedYear ?? syear}
                setSelectedThing={setSelectedYear}
              />
              {
                selectedStats === 'AgencyEmployeeNum' ?
                  <></>
                  :
                  <Dropdown
                    additionalClassName="stats-select-list small"
                    thingsList={smonths}
                    selectedYear={selectedYear ?? syear}
                    selectedThing={selectedMonth ?? smonth}
                    setSelectedThing={setSelectedMonth}
                  />
              }
              </>
          }

        </div>
        {
          selectedStats === Stats.TvRating ?
            <div className="row-box">
              <Dropdown
                additionalClassName="stats-select-list middle"
                thingsList={syears}
                selectedThing={selectedYear ?? syear}
                setSelectedThing={setSelectedYear}
              />
              <Dropdown
                additionalClassName="stats-select-list small"
                thingsList={smonths}
                selectedYear={selectedYear ?? syear}
                selectedThing={selectedMonth ?? smonth}
                setSelectedThing={setSelectedMonth}
              />
              <Dropdown
                additionalClassName="stats-select-list small"
                thingsList={DAYS_MENU}
                selectedThing={selectedDay ?? sday}
                setSelectedThing={setSelectedDay}
              />
            </div>
            :
            <></>
        }

        <div className="stats-contents">
          <h4 className="headline">{selectedStats?.name}</h4>
          <div className="graph">
            {
              selectedStats === Stats.AdvertiserAdOutlay || selectedStats === Stats.IndustryAdOutlay ?
                <AdOutlayChart/>
                :
                <></>
            }
            {
              selectedStats === 'AgencyEmployeeNum' ?
                <AgencyEmployeeNumChart/>
                :
                <></>
            }
            {
              selectedStats === Stats.TvRating || selectedStats === Stats.MonthlyTvRating ?
                <RatingChart/>
                :
                <></>
            }
            {
              selectedStats === Stats.PcDomain || selectedStats === Stats.MoblieApp ?
                <DomainChart/>
                :
                <></>
            }
          </div>
        </div>
      </section>
    </>

  )
}

export default Stat;
